import React from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "react-loading-skeleton";
import { IIdentity } from "../../../customTypings/user/Identity";
import { useAtom } from "@dbeining/react-atom";
import { userAtom } from "../../../atoms";

interface UserInfoCardProps {
    user: IIdentity | null;
    color: string;
    onEditDisplayName: () => void;
    onEditColor: () => void;
    onEditRoles: () => void;
    onEditPassword: () => void;
}

export const UserInfoCard: React.FC<UserInfoCardProps> = ({
    user,
    color,
    onEditDisplayName,
    onEditColor,
    onEditRoles,
    onEditPassword
}) => {
    const currentUser = useAtom(userAtom);

    return (
        <Card className="shadow">
            <Card.Body>
                <Row>
                    <Col lg={3} md={4} sm={12}>
                        <Form.Label>Email</Form.Label>
                    </Col>
                    <Col>
                        <Form.Label>
                            {user ? user.email : <Skeleton width="14em" />}
                        </Form.Label>
                    </Col>
                </Row>

                <hr />

                <Row>
                    <Col lg={3} md={4} sm={12}>
                        <Form.Label>Display name</Form.Label>
                    </Col>
                    <Col>
                        <Form.Label>
                            {user ? user.displayName : <Skeleton width="14em" />}
                        </Form.Label>
                    </Col>
                    {user && (
                        <Col xs="auto">
                            <Button
                                variant="outline-secondary"
                                className="border-0"
                                onClick={onEditDisplayName}
                                title="Edit display name"
                            >
                                <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                        </Col>
                    )}
                </Row>

                <hr />

                <Row>
                    <Col lg={3} md={4} sm={12}>
                        <Form.Label>Organisation</Form.Label>
                    </Col>
                    <Col>
                        <Form.Label>
                            {user ? user.organisation.displayName : <Skeleton width="14em" />}
                        </Form.Label>
                    </Col>
                </Row>

                <hr />

                <Row>
                    <Col lg={3} md={4} sm={12}>
                        <Form.Label>Colour</Form.Label>
                    </Col>
                    <Col>
                        {user ? (
                            <div className="user-colour"></div>
                        ) : (
                            <Skeleton width="6em" height="1.5em" />
                        )}
                    </Col>
                    {user && (
                        <Col xs="auto">
                            <Button
                                variant="outline-secondary"
                                className="border-0"
                                onClick={onEditColor}
                                title="Edit colour"
                            >
                                <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                        </Col>
                    )}
                </Row>

                <hr />

                <Row className="mb-2">
                    <Col lg={3} md={4} sm={12}>
                        <Form.Label>Roles</Form.Label>
                    </Col>
                    <Col>
                        <Form.Label>
                            {user ? (
                                user.roles.map((userRole) => (
                                    <div key={userRole.id}>{userRole.name}</div>
                                ))
                            ) : (
                                <Skeleton width="12em" count={6} />
                            )}
                        </Form.Label>
                    </Col>
                    {user && user?.id !== currentUser?.identity.id && (
                        <Col xs="auto">
                            <Button
                                variant="outline-secondary"
                                className="border-0"
                                onClick={onEditRoles}
                                title="Edit roles"
                            >
                                <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                        </Col>
                    )}
                </Row>

                <hr />

                <Row className="mb-2">
                    <Col lg={3} md={4} sm={12}>
                        Password
                    </Col>
                    <Col>
                        <Form.Label>
                            {user ? "••••••••" : <Skeleton width="8em" />}
                        </Form.Label>
                    </Col>
                    {user && user.id === currentUser?.identity.id && (
                        <Col xs="auto">
                            <Button
                                variant="outline-secondary"
                                className="border-0"
                                onClick={onEditPassword}
                                title="Edit password"
                            >
                                <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                        </Col>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
};
